/* Shared lightweight Back-in-Stock modal for off-product-page surfaces
 * (native outfit page + immersive look viewer). The full back-in-stock app
 * widget (extensions/back-in-stock-notifications) only mounts on product
 * templates because it reads #BackInStockProductJson. These surfaces live on
 * home/collection/metaobject pages, so this mini modal collects the email and
 * POSTs to the SAME app-proxy intents endpoint the extension uses.
 *
 * Public API:  window.SkiSisesBisMini.open({
 *   productId, productHandle, productTitle, productVendor, productImage,
 *   variantId, variantTitle, sku, price, language
 * })
 * App URL resolution order: window.SkiSisesBisConfig.apiBase → default.
 */
(function () {
  "use strict";
  if (window.SkiSisesBisMini) return;

  var DEFAULT_API = "https://ski-sises-back-in-stock.onrender.com";

  function _apiBase() {
    var cfg = window.SkiSisesBisConfig || {};
    return String(cfg.apiBase || DEFAULT_API).replace(/\/$/, "");
  }

  function _shopDomain() {
    try {
      if (window.Shopify && window.Shopify.shop) return window.Shopify.shop;
    } catch (e) {}
    return location.hostname;
  }

  function _lang(override) {
    var v = override || (document.documentElement.lang || (window.Shopify && window.Shopify.locale) || "it");
    var s = String(v).toLowerCase().split(/[-_]/)[0];
    return COPY[s] ? s : "it";
  }

  var COPY = {
    it: { title: "Avvisami quando disponibile", desc: "Inserisci la tua email. Ti invieremo un solo avviso quando questa taglia torna disponibile.", email: "Indirizzo email", submit: "Iscrivimi alla lista", sending: "Invio…", success: "Perfetto! Ti avviseremo via email quando torna disponibile.", error: "Non siamo riusciti a salvare la richiesta. Riprova.", invalid: "Inserisci un indirizzo email valido.", close: "Chiudi", consent: "Iscrivendoti, accetti di ricevere una notifica via email quando questo prodotto torna disponibile." },
    en: { title: "Notify me when available", desc: "Add your email. We'll send one alert when this size is back in stock.", email: "Email address", submit: "Join waitlist", sending: "Sending…", success: "Done! We'll email you when it's back in stock.", error: "We couldn't save your request. Please try again.", invalid: "Enter a valid email address.", close: "Close", consent: "By joining, you agree to receive a back-in-stock email notification for this product." },
    es: { title: "Avísame cuando esté disponible", desc: "Añade tu email. Te enviaremos un aviso cuando esta talla vuelva a estar disponible.", email: "Correo electrónico", submit: "Unirme a la lista", sending: "Enviando…", success: "¡Listo! Te avisaremos por email cuando vuelva a estar disponible.", error: "No pudimos guardar tu solicitud. Inténtalo de nuevo.", invalid: "Introduce un correo electrónico válido.", close: "Cerrar", consent: "Al unirte, aceptas recibir un aviso por email cuando este producto vuelva a estar disponible." },
    fr: { title: "Prévenez-moi quand disponible", desc: "Ajoutez votre e-mail. Nous vous enverrons une alerte quand cette taille sera de retour.", email: "Adresse e-mail", submit: "Rejoindre la liste", sending: "Envoi…", success: "C'est fait ! Nous vous préviendrons par e-mail dès le retour en stock.", error: "Nous n'avons pas pu enregistrer votre demande. Réessayez.", invalid: "Saisissez une adresse e-mail valide.", close: "Fermer", consent: "En vous inscrivant, vous acceptez de recevoir une alerte e-mail quand ce produit sera de retour." },
    de: { title: "Benachrichtigen, wenn verfügbar", desc: "Gib deine E-Mail-Adresse ein. Wir senden eine Nachricht, sobald diese Größe wieder verfügbar ist.", email: "E-Mail-Adresse", submit: "Warteliste beitreten", sending: "Wird gesendet…", success: "Erledigt! Wir benachrichtigen dich per E-Mail, sobald wieder verfügbar.", error: "Wir konnten deine Anfrage nicht speichern. Bitte erneut versuchen.", invalid: "Gib eine gültige E-Mail-Adresse ein.", close: "Schließen", consent: "Mit dem Beitritt stimmst du zu, eine E-Mail-Benachrichtigung zu erhalten, wenn dieses Produkt wieder verfügbar ist." }
  };

  var CSS = [
    ".bism-ov{position:fixed;inset:0;z-index:2147483600;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,.55);padding:18px;animation:bism-fade .2s ease}",
    "@keyframes bism-fade{from{opacity:0}to{opacity:1}}",
    ".bism-box{background:#fff;border-radius:16px;max-width:380px;width:100%;padding:22px 22px 20px;box-shadow:0 24px 70px rgba(0,0,0,.4);font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;box-sizing:border-box;position:relative}",
    ".bism-close{position:absolute;top:12px;right:12px;width:30px;height:30px;border:0;background:transparent;font-size:22px;line-height:1;cursor:pointer;color:#666}",
    ".bism-prod{display:flex;gap:10px;align-items:center;margin-bottom:12px}",
    ".bism-prod img{width:46px;height:46px;object-fit:cover;border-radius:8px;background:#eee;flex-shrink:0}",
    ".bism-pt{font-size:13.5px;font-weight:600;color:#111;line-height:1.25;margin:0}",
    ".bism-pv{font-size:12px;color:#888;margin:2px 0 0}",
    ".bism-title{font-size:16px;font-weight:700;color:#111;margin:0 0 6px}",
    ".bism-desc{font-size:12.5px;color:#666;margin:0 0 14px;line-height:1.4}",
    ".bism-inp{width:100%;padding:11px 12px;border:1px solid #ddd;border-radius:9px;font-size:14px;box-sizing:border-box;margin-bottom:10px}",
    ".bism-inp:focus{outline:none;border-color:#111}",
    ".bism-btn{width:100%;padding:12px;border:0;border-radius:9px;background:#111;color:#fff;font-size:14px;font-weight:600;cursor:pointer}",
    ".bism-btn:disabled{opacity:.6;cursor:default}",
    ".bism-consent{font-size:10.5px;color:#999;margin:10px 0 0;line-height:1.35}",
    ".bism-msg{font-size:13px;margin:0 0 10px;padding:9px 11px;border-radius:8px;display:none}",
    ".bism-msg.err{display:block;background:#fdecec;color:#b3261e}",
    ".bism-ok{text-align:center;padding:6px 0 2px}",
    ".bism-ok-ico{font-size:40px;line-height:1;margin-bottom:8px}",
    ".bism-ok-msg{font-size:13.5px;color:#333;line-height:1.45;margin:0 0 16px}"
  ].join("");

  var _cssDone = false;
  function _injectCss() {
    if (_cssDone) return;
    _cssDone = true;
    var s = document.createElement("style");
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function _esc(s) {
    return String(s == null ? "" : s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  }

  function _close() {
    var ov = document.querySelector(".bism-ov");
    if (ov) ov.remove();
  }

  function open(opts) {
    opts = opts || {};
    _injectCss();
    _close();
    var t = COPY[_lang(opts.language)];

    var ov = document.createElement("div");
    ov.className = "bism-ov";
    var imgHtml = opts.productImage ? '<img src="' + _esc(opts.productImage) + '" alt="">' : "";
    var prodHtml =
      '<div class="bism-prod">' + imgHtml +
        '<div><p class="bism-pt">' + _esc(opts.productTitle || "") + "</p>" +
        (opts.variantTitle ? '<p class="bism-pv">' + _esc(opts.variantTitle) + "</p>" : "") +
        "</div></div>";

    ov.innerHTML =
      '<div class="bism-box" role="dialog" aria-modal="true">' +
        '<button class="bism-close" aria-label="' + _esc(t.close) + '">&times;</button>' +
        '<h3 class="bism-title">' + _esc(t.title) + "</h3>" +
        prodHtml +
        '<div class="bism-form">' +
          '<p class="bism-desc">' + _esc(t.desc) + "</p>" +
          '<p class="bism-msg"></p>' +
          '<input type="email" class="bism-inp" placeholder="' + _esc(t.email) + '" autocomplete="email">' +
          '<button type="button" class="bism-btn">' + _esc(t.submit) + "</button>" +
          '<p class="bism-consent">' + _esc(t.consent) + "</p>" +
        "</div>" +
      "</div>";
    document.body.appendChild(ov);

    var box = ov.querySelector(".bism-box");
    var input = ov.querySelector(".bism-inp");
    var btn = ov.querySelector(".bism-btn");
    var msg = ov.querySelector(".bism-msg");
    var form = ov.querySelector(".bism-form");

    ov.addEventListener("click", function (e) { if (e.target === ov) _close(); });
    ov.querySelector(".bism-close").addEventListener("click", _close);
    setTimeout(function () { input.focus(); }, 50);
    input.addEventListener("keydown", function (e) { if (e.key === "Enter") btn.click(); });

    btn.addEventListener("click", function () {
      var email = (input.value || "").trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
        msg.textContent = t.invalid; msg.className = "bism-msg err"; return;
      }
      msg.className = "bism-msg"; msg.textContent = "";
      btn.disabled = true; btn.textContent = t.sending;
      var vId = String(opts.variantId || "");
      fetch(_apiBase() + "/api/public/back-in-stock/intents", {
        method: "POST",
        headers: { "Content-Type": "text/plain" },
        body: JSON.stringify({
          shopDomain: _shopDomain(),
          productId: String(opts.productId || ""),
          productHandle: opts.productHandle || "",
          productTitle: opts.productTitle || "",
          productVendor: opts.productVendor || null,
          productTypeAttribute: "custom.aaa",
          productTypeValue: opts.productTypeValue || null,
          productImageUrl: opts.productImage || null,
          variantId: vId,
          variantTitle: opts.variantTitle || "",
          sku: opts.sku || "",
          price: opts.price != null ? String(opts.price) : "",
          inventoryItemId: String(opts.inventoryItemId || vId),
          email: email,
          whatsappPhone: "",
          countryCode: opts.countryCode || (window.Shopify && window.Shopify.country) || "IT",
          marketCode: opts.marketCode || null,
          customerId: opts.customerId || null,
          quantity: 1,
          emailConsent: true,
          whatsappConsent: false,
          marketingConsent: false,
          consentText: t.consent,
          sourceUrl: location.href,
          websiteLanguage: _lang(opts.language),
          company: ""
        })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok || !res.d || res.d.success === false) throw new Error("fail");
          form.innerHTML =
            '<div class="bism-ok"><div class="bism-ok-ico">✓</div>' +
            '<p class="bism-ok-msg">' + _esc(t.success) + "</p>" +
            '<button type="button" class="bism-btn bism-ok-close">' + _esc(t.close) + "</button></div>";
          form.querySelector(".bism-ok-close").addEventListener("click", _close);
        })
        .catch(function () {
          msg.textContent = t.error; msg.className = "bism-msg err";
          btn.disabled = false; btn.textContent = t.submit;
        });
    });

    return box;
  }

  window.SkiSisesBisMini = { open: open, close: _close };
})();
